// extracted by mini-css-extract-plugin
module.exports = {"operation_white":"operation_white--2WqMq","hot":"hot--1MYk4","operation":"operation--3nu96"};